const styles = theme => ({
  fieldsHolder: {
    display: 'flex',
    alignItems: 'center',
    gap: '16px',
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
      alignItems: 'flex-start',
    },
  },

  fieldContainer: {
    flex: 1,
    [theme.breakpoints.down('sm')]: {
      width: '100%',
    },
  },

  searchBtnHolder: {
    marginTop: '24px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
  },

  searchBtn: {
    background: theme.palette.primary.adgmBlack,
    color: theme.palette.primary.white,
    padding: '16px 40px',
    borderRadius: '4px',
    '&:hover': {
      background: theme.palette.primary.adgmBlack,
    },
    '&:focus': {
      background: theme.palette.primary.adgmBlack,
    },

    [theme.breakpoints.down('sm')]: {
      width: '100%',
    },
  },

  searchBtnDisabled: {
    background: theme.palette.secondary.disableLightGray,
    color: theme.palette.primary.darkGrey,
  },

  searchBtnText: {
    fontSize: '16px',
    fontWeight: 600,
    lineHeight: '24px',
    border: '1px solid #0000',
  },

  divider: {
    margin: '24px 0',
    [theme.breakpoints.down('sm')]: {
      margin: '16px 0',
    },
  },

  companyCards: {
    display: 'flex',
    flexDirection: 'column',
    gap: '24px',
    [theme.breakpoints.down('sm')]: {
      gap: '16px',
    },
  },

  companyCard: {
    width: '100%',
    padding: '24px',
    backgroundColor: theme.palette.primary.white,
    borderRadius: '8px',
    border: `1px solid ${theme.palette.primary.borderColor}`,
    boxShadow: 'none',
    cursor: 'pointer',
  },

  companyCardSelected: {
    backgroundColor: theme.palette.primary.adgmGreenLight,
  },

  companyNameAndIconHolder: {
    display: 'flex',
    alignItems: 'center',
    gap: '12px',
  },

  companyNameHolder: {},

  companyCardRadioButton: {
    padding: 0,
    '& input:checked + div': {
      color: theme.palette.primary.adgmGreenDark,
    },
  },

  companyDetailsHolder: {
    display: 'flex',
    alignItems: 'center',
    gap: '32px',
    flexWrap: 'wrap',
  },

  pagination: {
    marginTop: '24px',
  },

  noDataFoundHolder: {
    [theme.breakpoints.down('sm')]: {
      padding: '16px 24px',
    },
  },
});

export default styles;
